import React from 'react'
import IconButton from '../../common/icon_button/icon_button'

const ButtonContainer = ({ children }) => <div className='task-time-button-container'>{children}</div>

export const TaskTime = ({ showTimecardAdd, showStart, showPause, showResume, onAddTime, onStart, onPause, onResume }) => {
  return (
    <div className='task-time-buttons'>
      {showTimecardAdd && (
        <ButtonContainer>
          <IconButton
            size='normal'
            icon='time'
            type='primary'
            onClick={onAddTime}
          />
        </ButtonContainer>
      )}
      {showStart && (
        <ButtonContainer>
          <IconButton
            size='normal'
            icon='play'
            type='primary'
            onClick={onStart}
          />
        </ButtonContainer>
      )}
      {showPause && (
        <ButtonContainer>
          <IconButton
            size='normal'
            icon='pause'
            type='primary'
            onClick={onPause}
          />
        </ButtonContainer>
      )}
      {showResume && (
        <ButtonContainer>
          <IconButton
            size='normal'
            icon='play'
            type='primary'
            onClick={onResume}
          />
        </ButtonContainer>
      )}
    </div>
  )
}
